import { createActionGroup, props } from "@ngrx/store";
import { DeliveryTerm } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataDeliveryTermsActions = createActionGroup({
    source: "Data / Delivery Terms",
    events: {
        "Load": props<{ companyId: string; languageCode: string }>(),
        "Load Success": props<{ deliveryTerms: DeliveryTerm[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
